// Copyright (c) 2016 Deere & Company

import ClaimAction, {getDefaultState as getClaimActionDefaultState} from './claim-action';
import ClaimBatteryAdditionalFailureInfo, {getDefaultState as getClaimBatteryAdditionalFailureInfoDefaultState} from './claim-battery-additional-failure-info';
import ClaimComplaintCause, {getDefaultState as getClaimComplaintCauseDefaultState} from './claim-complaint-cause';
import ClaimFailureInfo, {getDefaultState as getClaimFailureInfoDefaultState} from './claim-failure-info';
import ClaimRecordInfo, {getDefaultState as getClaimClaimRecordInfoDefaultState} from './claim-record-info';
import ClaimReferenceInfo, {getDefaultState as getClaimReferenceInfoDefaultState} from './claim-reference-info';
import ClaimReimbursementDetails, {getDefaultState as getClaimReimbursementDetailsDefaultState} from './claim-reimbursement-details';
import ClaimRgaStatus, {getDefaultState as getClaimRgaStatusDefaultState} from './claim-rga-status';
import ClaimRules, {getDefaultState as getClaimRulesDefaultState} from './claim-rules';
import ClaimValueDetails, {getDefaultState as getClaimValueDetailsDefaultState} from './claim-value-details';
import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import ClaimLabor from './claim-item-labor';
import ClaimOtherCredit from './claim-item-other-credit';
import ClaimPart from './claim-item-part';
import ClaimUseAmount from './claim-use-amount';
import ClaimVsrMessage from './claim-vsr-message';
import File from './file';
import t from 'tcomb';

const ClaimBattery = t.struct({
    additionalFailureInfo: ClaimBatteryAdditionalFailureInfo,
    allowedActions: t.list(ClaimAction, 'AllowedActions'),
    application: KeyValuePair,
    claimNumber: t.String,
    claimStatus: KeyValuePair,
    claimType: KeyValuePair,
    claimValueDetails: ClaimValueDetails,
    complaintCauseCommentsBasis: ClaimComplaintCause,
    customerSummary: CustomerSummary,
    errors: t.list(ClaimVsrMessage, 'Errors'),
    failureInfo: ClaimFailureInfo,
    file: t.maybe(t.list(File, 'Files')),
    goodsInstallationVat: t.maybe(KeyValuePair),
    hideClaimValueDetails: t.Bool,
    installedBy: KeyValuePair,
    isDuplicateClaim: t.Bool,
    isEditable: t.Bool,
    labor: t.maybe(t.list(ClaimLabor, 'Labor')),
    model: t.String,
    otherCredits: t.maybe(t.list(ClaimOtherCredit, 'OtherCredits')),
    parts: t.maybe(t.list(ClaimPart, 'Parts')),
    pin: t.String,
    previousInvoiceNumber: t.String,
    recordInfo: ClaimRecordInfo,
    referenceInfo: ClaimReferenceInfo,
    reimbursementDetails: ClaimReimbursementDetails,
    responsibleAccount: Dealer,
    retailInstallDate: t.maybe(t.Number),
    rgaStatus: ClaimRgaStatus,
    rules: ClaimRules,
    selectedAction: ClaimAction,
    serialNumber: t.String,
    showAmountsInLocalCurrency: t.maybe(t.Bool),
    showGoodsInstallationVat: t.Bool,
    showValidate: t.Bool,
    testResultsCode: t.String,
    useAmounts: t.list(ClaimUseAmount, 'UseAmounts'),
    validationFailed: t.Bool,
    version: t.String
}, {
    name: 'ClaimBattery',
    strict: true
});

export const getDefaultState = () => new ClaimBattery({
    additionalFailureInfo: getClaimBatteryAdditionalFailureInfoDefaultState(),
    allowedActions: [
        new ClaimAction({
            actionName: 'DRAFT',
            id: 'DRAFT',
            mode: 'CHG'
        })
    ],
    application: getKeyValuePairDefaultState(),
    claimNumber: '',
    claimStatus: getKeyValuePairDefaultState(),
    claimType: new KeyValuePair({
        key: 'ZZBT',
        value: ''
    }),
    claimValueDetails: getClaimValueDetailsDefaultState(),
    complaintCauseCommentsBasis: getClaimComplaintCauseDefaultState(),
    customerSummary: getCustomerSummaryDefaultState(),
    errors: [],
    failureInfo: getClaimFailureInfoDefaultState(),
    file: [],
    goodsInstallationVat: getKeyValuePairDefaultState(),
    hideClaimValueDetails: false,
    installedBy: getKeyValuePairDefaultState(),
    isDuplicateClaim: false,
    isEditable: true,
    labor: [],
    model: '',
    otherCredits: [],
    parts: [],
    pin: '',
    previousInvoiceNumber: '',
    recordInfo: getClaimClaimRecordInfoDefaultState(),
    referenceInfo: getClaimReferenceInfoDefaultState(),
    reimbursementDetails: getClaimReimbursementDetailsDefaultState(),
    responsibleAccount: getDealerDefaultState(),
    retailInstallDate: null,
    rgaStatus: getClaimRgaStatusDefaultState(),
    rules: getClaimRulesDefaultState(),
    selectedAction: getClaimActionDefaultState(),
    serialNumber: '',
    showAmountsInLocalCurrency: false,
    showGoodsInstallationVat: false,
    showValidate: true,
    testResultsCode: '',
    useAmounts: [],
    validationFailed: false,
    version: ''
});

ClaimBattery.prototype.vsrErrorMessages = function vsrErrorMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'E');

    return errorMessages;

};

ClaimBattery.prototype.vsrWarningMessages = function vsrWarningMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'W');

    return errorMessages;

};

ClaimBattery.prototype.vsrInfoMessages = function vsrInfoMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'I');

    return errorMessages;

};

export default ClaimBattery;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-battery.js